import React from 'react';
const Heading = ({ children, level, className }) => {
    const CustomHeading = `h${level}`;
    const attributes = { className, children };
    return <CustomHeading {...attributes}/>;
};
Heading.defaultProps = {
    className: '',
};
export default Heading;
